// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerDistanceMeter extends SceneLayer {
	/**
	 * Vytvoreni vrstvy pro 3d - zobrazeni rucniho mereni. Zobrazi markery + cary mezi nimi.
	 *
	 * @param {Array} points Body rucniho mereni WGS84 [x,y]
	 * @param {Array} linePoints Body rucniho mereni pro vykresleni car WGS84 [x,y,z]
	 * @param {Object} style Vizaulni nastaveni vrstvy
	 */
	constructor(scene, itemId, points, linePoints, style = {}) {
		super(scene, itemId);

		this._points = points;
		this._linePoints = linePoints;
		this._style = style;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerDistanceMeter",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.points = this._points;
		rd.linePoints = this._linePoints;
		rd.style = this._style;

		return rd;
	}

	/**
	 * Uprava dat - zpusobi prekresleni.
	 *
	 */
	update(...args) {
		this._points = args[0] || [];
		this._linePoints = args[1] || [];

		Object.assign(this._style, args[2] || {});

		this._onChange(this._scene.featureEvent("layerDistanceMeterUpdate", true, true), args);
	}
}
